import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Statistic,
  Spin,
  Table,
  Select,
  Form,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import CustomButton from "../../../components/custom/CustomButton";
const { Text, Title } = Typography;

const columns = [
  {
    title: "Branch Name",
    dataIndex: "officeName",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Product Name",
    dataIndex: "productName",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Currency Code",
    dataIndex: "currencyCode",
  },

  {
    title: "Category Name",
    dataIndex: "categoryName",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Provisioning Amount",
    dataIndex: "provisioningAmount",
  },
  {
    title: "Liability Account (CR)",
    dataIndex: "liabilityAccount",
  },
  {
    title: "Expense Account (DR)",
    dataIndex: "expenseAccount",
  },
];

const ViewGLA1100 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [provisioningEntryDetail, setProvisioningEntryDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [officeData, setOfficeData] = useState([]);
  const [loanProduct, setLoanProduct] = useState([]);
  const [provisioningCategory, setProvisioningCategory] = useState([]);
  const [provisioningEntryList, setProvisioningEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    getOffice();
    getLoanProducts();
    getProvisioningcategory();
    getDetailById(state);
    getProvisioningEntriesAction(state);
  }, []);

  function getOffice() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetOfficeList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  }

  function getLoanProducts() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetLoanProductList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setLoanProduct(temp);
      }
    });
  }

  function getProvisioningcategory() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetProvisioningcategory, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let temp = [];

        console.log(objList);

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.categoryName,
          });
        });

        setProvisioningCategory(temp);
      }
    });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.DetailProvisioningEntries}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objDetail = res;
        setProvisioningEntryDetail(objDetail);

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: cnt.RIGHT_DELETE_BTN,
        // });

        setIsLoading(false);
      }
    });
  };

  const getProvisioningEntriesAction = (params) => {
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      `${definedApi.GetSpecificProvisioningList}entryId=${params.key}&limit=10&offset=0`,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[1].defaultUserMessage);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id ? element?.id : "-",
              officeName: element?.officeName ? element?.officeName : "-",
              productName: element?.productName ? element?.productName : "-",
              currencyCode: element?.currencyCode ? element?.currencyCode : "-",
              categoryName: element?.categoryName ? element?.categoryName : "-",
              provisioningAmount: element?.amountreserved ? (
                <Statistic
                  value={element?.amountreserved}
                  precision={2}
                  valueStyle={{ fontSize: "16px" }}
                />
              ) : (
                "-"
              ),
              liabilityAccount: element?.liabilityAccountName
                ? element?.liabilityAccountName
                : "-",
              expenseAccount: element?.expenseAccountName
                ? element?.expenseAccountName
                : "-",
            });
          });

          //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
          // setProvisioningEntryList(tempArray.filter((item) => item.disabled === false));
          setProvisioningEntryList(tempArray);

          //keep the orginal data to use after gList is modified when change from autorise to disable
          setOriginalList(tempArray);

          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  const onSubmit = (formValues) => {
    const params = {
      categoryId: formValues.categoryId,
      entryId: state.key,
      limit: 10,
      officeId: formValues.officeId,
      offset: 0,
      productId: formValues.productId,
    };

    const url = `${definedApi.SearchProvisioningEntries}`;
    const body = {
      ...formValues,
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            officeName: element?.officeName ? element?.officeName : "-",
            productName: element?.productName ? element?.productName : "-",
            currencyCode: element?.currencyCode ? element?.currencyCode : "-",
            categoryName: element?.categoryName ? element?.categoryName : "-",
            provisioningAmount: element?.amountreserved ? (
              <Statistic
                value={element?.amountreserved}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            liabilityAccount: element?.liabilityAccountName
              ? element?.liabilityAccountName
              : "-",
            expenseAccount: element?.expenseAccountName
              ? element?.expenseAccountName
              : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        setProvisioningEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.viewProvisioningEntriesDetail}
        pageItems={appStatic.viewProvisioningEntriesItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Card
          style={{
            width: "100%",
            marginBottom: 20,
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row justify={"space-between"}>
              <Title level={3}>
                {appLabel.createdBy}: {provisioningEntryDetail.createdUser}
              </Title>
              <Title level={3}>
                {appLabel.createdOn}: {provisioningEntryDetail.createdDate}
              </Title>
              <Title level={3}>
                {appLabel.amountToBeReserved}:{" "}
                {provisioningEntryDetail.reservedAmount}
              </Title>
            </Row>
          }
          tabProps={{
            size: "middle",
          }}
        >
          <Form
            form={useForm}
            onFinish={onSubmit}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row style={{ justifyContent: "space-between" }}>
              <Form.Item
                name="officeId"
                label={
                  <Text style={{ fontSize: "16px" }}>{appLabel.office}</Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.office)}
                  style={{ width: "30vh" }}
                  showSearch
                  options={officeData}
                />
              </Form.Item>
              <Form.Item
                name="productId"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {appLabel.loanProduct}
                  </Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.loanProduct)}
                  style={{ width: "30vh" }}
                  showSearch
                  options={loanProduct}
                />
              </Form.Item>

              <Form.Item
                name="categoryId"
                label={
                  <Text style={{ fontSize: "16px" }}>{appLabel.category}</Text>
                }
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(appLabel.category)}
                  style={{ width: "30vh" }}
                  showSearch
                  options={provisioningCategory}
                />
              </Form.Item>
            </Row>
            <Row>
              <CustomButton
                content="Search"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
            </Row>
          </Form>
          <Table columns={columns} dataSource={provisioningEntryList} />
        </Card>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA1100);
